import { queryOptions } from '@tanstack/react-query';
import { mapResponseError } from '@mybusinessmate/api-client';
import { api } from './api';

/** A short-lived signed link to a stored file. Fetched through the API (the session decides who may see what). */
export async function signedDownloadUrl(key: string): Promise<string> {
  const res = await api.api.storage['presigned-download'].$post({ json: { key } });
  if (!res.ok) throw await mapResponseError(res);
  const { downloadUrl } = await res.json();
  if (!downloadUrl) throw new Error('No download link');
  return downloadUrl;
}

/** The link is good for minutes, so a picture is re-signed well before it lapses and not on every render. */
export const assetUrlQuery = (key: string) =>
  queryOptions({
    queryKey: ['asset-url', key] as const,
    queryFn: () => signedDownloadUrl(key),
    staleTime: 5 * 60_000,
    gcTime: 10 * 60_000,
    retry: false,
  });
